// extracted by mini-css-extract-plugin
export default {"close-button":"TermAndCondition_close-button__dMayF","content":"TermAndCondition_content__MxGcT","title":"TermAndCondition_title__f5uKl"};